import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ActionTypes } from "../types";

export const login = () => {
  return async (dispatch) => {
   let isAuthenticatin = true
    await dispatch({ type: ActionTypes.LOGIN, payload: isAuthenticatin });
  };

};
export const logout = () => {
  return async (dispatch) => {
  
    let isAuthenticatin = false
      await dispatch({ type: ActionTypes.LOGOUT, payload: isAuthenticatin });
  };

};


